import React from 'react';

const BellIcon = (): React.ReactElement => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="18" viewBox="0 0 16 18">
    <path strokeWidth=".5" d="M8.2 1C5.706 1 3.7 3.139 3.7 5.68c0 4.044-.928 4.721-2.57 6.671-.083.096-.13.222-.13.349v1.44c0 .283.257.54.54.54h3.966c.093 1.403 1.268 2.52 2.694 2.52s2.6-1.117 2.694-2.52h3.966c.283 0 .54-.257.54-.54V12.7c0-.127-.047-.253-.13-.349-1.642-1.95-2.57-2.627-2.57-6.671C12.7 3.139 10.694 1 8.2 1h0zm0 1.08c1.873 0 3.42 1.626 3.42 3.6 0 4.109 1.164 5.396 2.7 7.211v.709H2.08v-.709c1.536-1.815 2.7-3.102 2.7-7.211 0-1.974 1.547-3.6 3.42-3.6zm-1.586 12.6h3.172c-.091.815-.743 1.44-1.586 1.44-.843 0-1.495-.625-1.586-1.44z" />
  </svg>
);

export default BellIcon;
